'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var CHAT = 'M4.77404 3C4.28365 3 3.86539 3.17308 3.51923 3.51923C3.17307 3.86539 3 4.28365 3 4.77404V15.5913C3 16.0817 3.17307 16.5072 3.51923 16.8678C3.86539 17.2284 4.28365 17.4087 4.77404 17.4087H17.4087L21 21V4.77404C21 4.28365 20.8269 3.86539 20.4808 3.51923C20.1346 3.17308 19.7163 3 19.226 3H4.77404Z';
var IconChat = lib.variant('IconChat', icon.Icon, {
    path: CHAT,
});

exports.IconChat = IconChat;
//# sourceMappingURL=index-ca2ef560.js.map
